// extracted by mini-css-extract-plugin
module.exports = {"ErrorScreen":"NotFoundScreen_ErrorScreen__2obnN"};